const EsgReportData = ({ data }) => {
    return (
        <>
            <tr>
                <td>2021</td>
                <td>emission</td>
                <td>GHG Emission</td>
                <td><p> </p><div class="ms-2 me-auto last-child-red">

                    <ul>

                        <div key={1}>
                            <span > <b>scope1: </b> 2.23 </span>
                        </div>
                        <div key={2}>
                            <span > <b>scope2: </b> 5.66 </span>
                        </div>
                        <div key={3}>
                            <span > <b>scope3: </b> 9.8 </span>
                        </div>
                        <div key={4}>
                            <span > <b>total: </b> 17.69 </span>
                        </div>

                    </ul>
                </div></td>
            </tr>
            {

                data && Object.keys(data).length > 0 ? (data.map((curData, index) => {
                    const { question, year, answer, supplier, category, data } = curData;

                    return (
                        <tr key={index}>
                            {/* <td>{supplier}</td> */}
                            <td>{year}</td>
                            <td>{category}</td>
                            <td>{question}</td>
                            <td><p>{answer} </p><div class="ms-2 me-auto last-child-red">
                                {data ? (
                                    <ul>
                                        {Object.entries(data).map(([key, value]) => (
                                            <div key={key}>
                                                <span > <b>{key}: </b> {value} </span>
                                            </div>
                                        ))}
                                    </ul>
                                ) : (
                                    '-'
                                )}
                            </div></td>
                            {/* <td></td> */}
                            {/* <td>   <div class="ms-2 me-auto last-child-red">
                                {data && Object.keys(data).map((key, i) => (
                                    < span key={i}> <b>{key}: </b> {data[key]} </span>
                                ))}

                            </div></td> */}
                        </tr>
                    )
                })
                ) : (
                    <span>No Esg reports data available.</span>
                )
            }
        </>
    )
}

export default EsgReportData;